export enum ExperimentTakeoverSource {
  CAMPAIGN_EDITOR = 'campaignEditor',
  CAMPAIGN_INDEX = 'campaignIndex',
  EXPERIMENT_NAME_INDEX = 'experimentNameIndex',
  EXPERIMENT_ACTION_MENU_INDEX = 'experimentActonMenuIndex',
  EXPERIMENT_ANALYTICS = 'experimentAnalytics',
  WORKFLOW_NODE_EDITOR = 'workflowNodeEditor',
  EXPERIMENT_INDEX_CHOOSE_CAMPAIGN_TAKEOVER = 'experimentIndexChooseCampaignTakeover',
}
